import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase';
import { NgForm } from '@angular/forms';
import { UserService } from '../../service/user.service';
import { Location } from '@angular/common';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../../service/storage.service';
import { MyfireService } from '../../service/myfire.service';
import { MKBN } from '../../dg/mkbBig';
@Component({
  selector: 'app-nalaz',
  templateUrl: './nalaz.component.html',
  styleUrls: ['./nalaz.component.css']
})
export class NalazComponent implements OnInit {
  istorijaid: any;
  pacijentid: any;
  istorijaRef: any = {};
  dgRef: any;
  istorija?: any = {};
  istorijaNalaz: any;
  dijagnozaData: any = [];
  personalPostRef: any;
  href: string;
  user;
  obrisi = true;
  dijagnoza = true;
  terapija = false;
  nalaz = true;
  MKB: any = [];
  searchDg: any = '';
  newHref: any;
  dijagnozaKey: any;
  loading = false;
  today: number = Date.now();
  values: any = [];
  ocitvanje = false;
  dijagnozaTarget: any;
  error: any;
  filteredMKB: any = [];
  proveraFilteredMKB = '';
  napomena;
  selectDg;
  terap;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private location: Location,
    private http: HttpClient,
    private myFire: MyfireService
  ) {
    this.istorijaid = this.route.snapshot.params['id'];
    this.user = this.userService.getProfile();
    this.href = this.router.url;

    this.istorijaRef = firebase.database().ref(this.href.toString());
    this.dgRef = firebase.database().ref(this.href.toString() + '/dijagnoza/');
    this.pacijentid = route.snapshot.url[1].path.toString();
    this.MKB = [...MKBN];
    this.href = this.router.url;
    this.newHref = this.href.replace('/dijagnoza', '');
    this.user = userService.getProfile();
  }
  @ViewChild('ter') ter: any;
  @ViewChild('nal') nal: any;
  editorConfig: AngularEditorConfig = {
    editable: true,
    height: '30rem',
    minHeight: '25rem',
    placeholder: 'Ovde mozete pisati...',
    translate: 'no'
  };
  editorConfig2: AngularEditorConfig = {
    editable: true,
    height: '10rem',
    minHeight: '10rem',
    placeholder: 'Ovde mozete pisati...',
    translate: 'no'
  };
  update(form: NgForm) {
    let nalazForma = form.value.nalazForma;
    let terapijaForma = form.value.terapijaForma;

    if (nalazForma === undefined) {
      nalazForma = '';
    }
    if (terapijaForma === undefined) {
      terapijaForma = '';
    }

    firebase
      .database()
      .ref('zavrsi/' + this.istorijaid)
      .set({
        data: this.istorija
      });
    this.istorijaRef = firebase
      .database()
      .ref(this.href.toString())
      .update({
        nalaz: nalazForma,
        status: 'zatvoreno',
        th: terapijaForma
      });
    firebase
      .database()
      .ref('danas/' + this.pacijentid)
      .remove();
  }

  updatePregled(form: NgForm) {
    const pregled = form.value.pregled;
    this.istorijaRef = firebase
      .database()
      .ref(this.href.toString())
      .update({
        pregled: pregled
      });
  }
  print(form: NgForm): void {
    let nalaz = form.value.nalazForma;
    let th = form.value.terapijaForma;
    if (nalaz === undefined) {
      nalaz = '';
    }
    if (th === undefined || th === null || th === '<br>') {
      th = '';
    }
    if (this.dijagnozaData.length === 0) {
      alert('Morate dodati dijagnozu!');
      return;
    }

    this.istorijaRef = firebase
      .database()
      .ref(this.href.toString())
      .update({
        nalaz: nalaz,
        th: th
      });

    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open(
      '',
      '_blank',
      'top=0,left=0,height=595px,width=842px'
    );
    popupWin.document.open();
    popupWin.document.write(
      '<link rel="stylesheet" href="../../assets/print.css" type="text/css" />',
      '<meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1" /> '
    );
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>

          <style type="text/css" media="all">

          </style>

        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }
  saveTh(f: NgForm) {
    const th = f.value.terapijaForma;
    const nalaz = f.value.nalazForma;
    this.istorijaRef = firebase
      .database()
      .ref(this.href.toString())
      .update({
        th: th,
        nalaz: nalaz
      });
  }
  deleteKontakt() {
    if (confirm('Da li ste sigurni da zelite da obrisete?')) {
      this.istorijaRef = firebase
        .database()
        .ref(this.href.toString())
        .remove();
      this.location.back();
    }
  }
  delete(dgId, d) {
    if (this.user.name !== d.data.doktor) {
      alert('NE MOZETE BRISATI TUDJE DIJAGNOZE!');
      return;
    }
    if (confirm('Da li ste sigurni da zelite da obriste dijagnozu?')) {
      firebase
        .database()
        .ref(this.href.toString() + '/dijagnoza/' + dgId)
        .remove()
        .then(() => {
          this.router.navigate([this.href.toString() + '/brisanje/']);
        })
        .then(() => {
          this.location.back();
        });
    }
  }

  toggleth() {
    this.terapija = !this.terapija;
  }
  async Get(naslov, nalaz, email) {
    if (nalaz === undefined) {
      return;
    }
    const htmlNew = nalaz.replace(/&nbsp;/g, ' ');
    await this.http
      .get(
        `${this.myFire.getEmail()}dest=${email}&naslov=${naslov}&body=${htmlNew}`,
        {
          responseType: 'text'
        }
      )
      .subscribe();
  }

  nazad() {
    this.location.back();
  }

  submitDg(form: NgForm) {
    let napomena = form.value.napomena;
    const dijagnoza = form.value.selectDg;

    if (dijagnoza === undefined) {
      // throw new Error("Morate uneti dijagnozu!!!").message;
      return null;
    }
    if (napomena === undefined) {
      napomena = '';
    }
    if (dijagnoza === undefined && napomena.length >= 1) {
      // throw new Error("Morate uneti dijagnozu!!!").message;
      return null;
    }
    return firebase
      .database()
      .ref(this.newHref.toString() + '/dijagnoza/')
      .push({
        dijagnoza,
        napomena,
        date: this.today,
        doktor: this.user.name
      })

      .then(() => {
        napomena = '';
        this.filteredMKB = [];
        this.searchDg = '';
        form.resetForm();
      })
      .catch(err => {
        this.error = err.message;
      });
  }

  filterArray() {
    this.proveraFilteredMKB = '';
    this.filteredMKB = this.MKB.filter(word =>
      word.dijagnoza.toLowerCase().includes(this.searchDg.toLowerCase())
    );
    if (this.filteredMKB.length < 1) {
      this.proveraFilteredMKB = 'Molimo vas probajte drugu dijagnozu.';
    }
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.istorijaRef.on('value', snapshot => {
      this.istorija = snapshot.val();
      if (this.istorija.doktor === this.user.name) {
        this.ter.editorToolbar.showToolbar = true;
        this.nal.editorToolbar.showToolbar = true;
      } else {
        this.ter.editorToolbar.showToolbar = false;
        this.nal.editorToolbar.showToolbar = false;
      }
    });
    this.dgRef.on('child_added', data => {
      this.dijagnozaData.push({
        key: data.key,
        data: data.val()
      });
    });
  }
}
